const config = require('../../config/config');

const servicesSettings = config.services;
const basePath = `${servicesSettings.MG_PROTOCOL}://${servicesSettings.MG_DOMAIN}:${servicesSettings.MG_PORT}${servicesSettings.MG_SERVICES_BASE}`;

/**
 * Throw response if invalid status code
 * @param  {[type]} response [description]
 * @return {[type]}          [description]
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  throw response;
}

/**
 * Transform response to json
 * @param  {[type]} response [description]
 * @return {[type]}          [description]
 */
function parseJSON(response) {
  return response.json();
}

module.exports = {
  all(offset, limit, typeFilter, makeFilter) {
    const params = [];

    if (offset) {
      params.push(`offset=${offset}`);
    }

    if (limit) {
      params.push(`limit=${limit}`);
    }

    if (typeFilter) {
      params.push(`type=${typeFilter}`);
    }

    if (makeFilter) {
      params.push(`make=${makeFilter}`);
    }

    return fetch(
      `${basePath}leads?${params.join('&')}`
    ).then((response) => {
      const total = response.headers.get('X-Total-Count');

      return response.json().then((leads) => {
        return [leads, total];
      });
    });
  },
  getById(id) {
    return fetch(`${basePath}leads/${id}`)
      .then(checkStatus)
      .then(parseJSON);
  },
  save(lead) {
    return fetch(`${basePath}leads`, {
      method: 'POST',
      body: JSON.stringify(lead)
    })
      .then(checkStatus)
      .then(parseJSON);
  },
  ignore(leadId) {
    return fetch(`${basePath}leads/${leadId}/ignored`, {
      method: 'POST'
    })
      .then(checkStatus)
      .then(parseJSON);
  },
  unignore(leadId) {
    return fetch(`${basePath}leads/${leadId}/ignored`, {
      method: 'DELETE'
    })
      .then(checkStatus)
      .then(parseJSON);
  },
  getRules(formType) {
    return fetch(`${basePath}forms/${formType}`)
      .then(checkStatus)
      .then(parseJSON);
  },
  getStatus() {
    return fetch(`${basePath}status`)
      .then(checkStatus)
      .then(parseJSON);
  }
};
